import script from "./SvgVue.vue?vue&type=script&setup=true&lang=ts"
export * from "./SvgVue.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__